import { getIsRetailRpc } from 'eligibility-engine-service-types';
import { rpcClient } from '../client';
export const fetchIsRetail = () => rpcClient.call(getIsRetailRpc, {});